import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import PictureLayout from 'shared/PictureLayout/PictureLayout'
import styles from './PictureWithComment.style'

const propTypes = {
    image: PropTypes.string,
    comment: PropTypes.string,
    number: PropTypes.number.isRequired,
}

const PictureWithComment = ({
    image,
    comment,
    number,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <PictureLayout
            title={t('PICTURES')}
            image={image}
            customClasses={{ actions: classes.actions }}
            noStepUI
        >
            <div css={classes.main}>
                <div>
                    <Typography
                        variant="h3"
                        css={classes.title}
                    >
                        {`${t('PICTURE')} ${number}`}
                    </Typography>
                </div>
                <div>
                    <Typography
                        variant="h3"
                        css={classes.description}
                        style={{ whiteSpace: 'pre-wrap' }}
                    >
                        {comment}
                    </Typography>
                </div>
            </div>
        </PictureLayout>
    )
}

PictureWithComment.propTypes = propTypes

export default PictureWithComment
